import { post } from "../../service/api";

const ReCreateFailedVat = async (id) => {
  try {
    const response = await post(`/vat/${id}/reCreate`);
    return response;
  } catch (error) {
    console.error("Error createInvoice:", error);
    throw error;
  }
};

export default ReCreateFailedVat;
